import {PropsWithChildren} from 'react'
import {body} from './body.module.scss'

type Props = PropsWithChildren<{}>

export const Body = ({children}: Props) => <div className={body}>{children}</div>
